﻿import { setCookie } from "../../Shared/Assets/src/cookie";

const alertBanners = document.querySelectorAll(
  "[data-alert-banner]"
) as NodeListOf<HTMLElement>;

alertBanners.forEach(banner => {
  const alertLevel = banner.dataset.alertBannerLevel;
  const cookieName = banner.dataset.alertBannerCookieName;
  const cookieExpireInDays =
    alertLevel === "emergency"
      ? undefined // Session cookie
      : 100;

  const actionButton = banner.querySelector("[data-alert-banner-dismiss]") as HTMLElement;

  if (cookieName === undefined) {
    console.error("No cookie name found, unable to bind listener");
  } else {
    actionButton.addEventListener("click", () => {
      setCookie(cookieName, "hide", cookieExpireInDays);
      banner.remove();
    });
  }
});
